import React, { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';

function formatDateTime(dateStr) {
    return new Date(dateStr).toLocaleString();
}

function ShipmentList() {
    const [shipments, setShipments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const token = localStorage.getItem('authToken');

    const fetchShipments = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/shipments`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const result = await res.json();
            setShipments(result.shipments || []);
        } catch (err) {
            console.error('Error fetching shipments:', err);
        }
    };

    useEffect(() => {
        fetchShipments();
    }, []);

    const filteredShipments = shipments.filter((s) =>
        Object.values(s).some((val) =>
            String(val || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">Shipments</h2>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white"><FaSearch /></span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table-primary">
                        <tr>
                            <th>Order Number</th>
                            <th>Customer</th>
                            <th>Address</th>
                            <th>Products</th>
                            <th>Payment</th>
                            <th>Order Date</th>
                            <th>Courier Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredShipments.map((order) => (
                            <tr key={order.ShipmentId}>
                                <td>{order.OrderNumber}</td>

                                <td>
                                    <div><strong>Name:</strong> {order.FirstName} {order.LastName}</div>
                                    <div><strong>Phone:</strong> {order.PhoneNumber}</div>
                                </td>

                                <td>
                                    <div>{order.Address}</div>
                                    {order.Landmark && <div><strong>Landmark:</strong> {order.Landmark}</div>}
                                    <div>{order.City}, {order.State} - {order.Pincode}</div>
                                </td>

                                <td>
                                    {Array.isArray(JSON.parse(order.Products || '[]')) &&
                                        JSON.parse(order.Products).map((product, idx) => (
                                            <div key={idx} className="mb-2">
                                                <div><strong>{product.name}</strong></div>
                                                <div>Size: {product.size}</div>
                                                <div>Qty: {product.quantity}</div>
                                            </div>
                                        ))}
                                </td>

                                <td>
                                    <div><strong>Status:</strong> {order.PaymentStatus}</div>
                                    <div><strong>Mode:</strong> {order.PaymentMode}</div>
                                    <div><strong>Type:</strong> {order.PaymentType}</div>
                                </td>

                                <td>{formatDateTime(order.OrderDateTime)}</td>

                                <td>
                                    <div><strong>Name:</strong> {order.CourierName || '-'}</div>
                                    <div><strong>Link:</strong> {order.CourierLink || '-'}</div>
                                    <div><strong>Docket:</strong> {order.CourierDocketNumber || '-'}</div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ShipmentList;